<template>
  <div>
    <el-dialog
      title="Danh sách phòng"
      :visible.sync="dialogCustomerDisplayVisible"
      :close-on-click-modal="false"
      width="85%"
      @closed="onCloseRoomDialog"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <!-- <div class="das-form-group">
                  <div class="das-form-group-title">Thông tin đoàn</div>
                  <div class="das-form-row">
                    <div class="das-form-col w-33">
                      <div class="das-form-input">
                        <div class="label">Mã đoàn</div>
                        <div class="child-w-80">
                          <input
                            v-model="groupMasterData.booking_code"
                            type="text"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col w-33">
                      <div class="das-form-input">
                        <div class="label">Ngày đến</div>
                        <div class="child-w-80">
                          <input
                            v-model="groupMasterData.first_arrival_date"
                            type="text"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col w-33">
                      <div class="das-form-input">
                        <div class="label">Công ty, đại lý du lịch</div>
                        <div class="child-w-80">
                          <input
                            v-model="groupMasterData.agent_name"
                            type="text"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="das-form-row">
                    <div class="das-form-col w-33">
                      <div class="das-form-input">
                        <div class="label">Ngày đi</div>
                        <div class="child-w-80">
                          <input
                            v-model="groupMasterData.last_departure_date"
                            type="text"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
            <hr />
            <div class="das-form-group">
              <div v-loading="roomTableLoading" style="height: 300px">
                <GridVx
                  ref="roomTable"
                  :columns="roomColumns"
                  :rows="roomRows"
                  dom-layout="scroll"
                  class="agGrid"
                  @selectionChanged="onSelectedRoom"
                />
              </div>
              <div class="checkin-group">
                <span class="checkin"
                  >Số phòng đã checkin: {{ checkinRooms }}</span
                >
                <span class="uncheckin"
                  >Số phòng đã checkin: {{ uncheckinRooms }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers-seperate">
          <div class="button-containers-outline">
            <button
              class="btn primary small outline"
              :disabled="selectedRoom === null"
              @click="dialogCancelRoomVisible = true"
            >
              Hủy đặt phòng
            </button>
            <button
              class="btn primary small outline"
              :disabled="selectedRoom === null"
              @click="openCancelCheckinRoom"
            >
              Hủy check-in
            </button>
          </div>
          <div class="button-containers-primary">
            <button
              class="btn primary small"
              :disabled="selectedRoom === null"
              @click="checkinRoom"
            >
              Check-in
            </button>
            <button class="btn primary small" @click="checkinAllRooms">
              Check-in toàn bộ
            </button>
          </div>
        </div>
        <div class="button-containers close-btn">
          <button
            class="btn primary small outline"
            @click="dialogCustomerDisplayVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>

    <!--Cancel Room Dialog -->
    <el-dialog
      title="Hủy đặt phòng"
      :visible.sync="dialogCancelRoomVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col w-50">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ 'Lý do hủy' }}
                    </div>
                    <div class="child-w-80">
                      <textarea
                        v-model="cancelRoomExplaination"
                        style="width: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="fnConfirmCancelRoom"
          >
            Xác nhận
          </button>
          <button
            class="btn primary small"
            @click="dialogCancelRoomVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { getBookingGroupListApi } from '@/api/booking_service/missionBookingGroupApi'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// import Multiselect from 'vue-multiselect'
export default {
  components: {
    // SingleCalendar,
    // Multiselect
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cancelRoomExplaination: null,

      selectedRoom: null,

      dialogCustomerDisplayVisible: false,
      dialogCancelRoomVisible: false,
      dialogCancelCheckinVisible: false,

      roomColumns: [
        {
          headerName: 'Mã đặt phòng',
          field: 'no',
          width: 50
        },
        {
          headerName: 'Mã xác nhận',
          field: 'department_name'
        },
        {
          headerName: 'Tên khách',
          field: 'status',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Số phòng',
          field: 'content',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Hạng phòng',
          field: 'exe_time',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: ' Ngày đến',
          field: 'implementer',
          cellRenderer: params => {
            return moment(params.value).format('YYYY-MM-DD')
          },
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Ngày đi',
          field: 'completion_time',
          cellRenderer: params => {
            return params.value ? moment(params.value).format('YYYY-MM-DD') : ''
          },
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Số lượng khách',
          field: 'create_user_name',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Công ty đại lý du lịch',
          field: 'create_date',
          width: 200,
          cellRenderer: params => {
            return params.value
              ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
              : ''
          },
          cellClass: 'grid-cell-centered'
        }
      ],
      roomRows: [],
      checkinRooms: 0,
      uncheckinRooms: 0,

      roomTableLoading: false,

      groupMasterData: {
        no: null,
        id: null,
        name: null,
        note: null,
        status: null,
        create_date: null,
        create_user_id: null,
        external_id: null,
        booking_code: null,
        confirm_code: null,
        first_arrival_date: null,
        last_departure_date: null,
        agent_id: null,
        agent_name: null,
        user_create: null,
        status_code: null
      }
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.dialogCustomerDisplayVisible = this.dialogVisible
        if (val) {
          this.fnGetRoomList()
        }
      }
    },
    selectedData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.groupMasterData = this.selectedData
        }
      }
    }
  },
  methods: {
    // DATA
    async fnGetRoomList() {
      this.roomTableLoading = true
      getBookingGroupListApi({ booking_group_id: this.selectedData.id })
        .then(res => {
          //   this.roomRows = res.data
          this.roomRows = [{ no: 1, code: 'hehe' }]
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.roomTableLoading = false
        })
    },

    onSelectedRoom(selectRoom) {
      this.selectedRoom = selectRoom[0]
    },

    async fnConfirmCancelRoom() {
      // call api
      alert('cancel room!!')
      this.cancelRoomExplaination = ''
      this.dialogCancelRoomVisible = false
    },

    openCancelCheckinRoom() {
      // call api
      alert('Huy checkin thanh cong')
    },
    checkinRoom() {
      alert('Check in room id: ' + this.selectedRoom.no)
    },
    checkinAllRooms() {
      alert('Check in toàn bộ phòng thành công ')
    },

    // DIALOG
    onCloseRoomDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.w-33 {
  width: 33%;
}
.w-25 {
  width: 25%;
}
.mr-2 {
  margin: 0 10px 0 0;
}
.el-date-editor.el-input {
  width: 90%;
}
.ag-theme-balham .ag-row-selected {
  background-color: #357456 !important;
}
/* .button-containers {

  } */
.close-btn {
  padding-top: 10px;
}
.checkin-group {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0 0;
}
.checkin {
  padding-top: 10px;
}
.button-containers-seperate {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 20px;
}
.button-containers-outline,
.button-containers-primary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
</style>
